<template>
    <div class="lang-toggler" @click="toggleLang">
        <span class="text-h7"> {{ currentLocale === 'uk' ? 'UK' : 'EN' }} </span>
        <img v-if="currentLocale === 'en'" src="@/assets/images/en-flag.svg" alt="" />
        <img v-if="currentLocale === 'uk'" src="@/assets/images/uk-flag.svg" alt="" />
    </div>
</template>

<script>
export default {
    name: 'LangToggler',
    computed: {
        currentLocale() {
            return this.$i18n.locale
        }
    },
    methods: {
        toggleLang() {
            const newLang = this.currentLocale === 'uk' ? 'en' : 'uk'

            this.$i18n.locale = newLang
            localStorage.setItem('lang', newLang)
        }
    }
}
</script>

<style scoped lang="scss">
.lang-toggler {
    padding: 0.625rem;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 4rem;
    border-radius: 0.625rem;
    cursor: pointer;
    user-select: none;
    transition: all ease-in-out 0.3s;

    &:hover {
        box-shadow: $shadow-sm;
    }

    span {
        margin-right: 0.25rem;
    }

    img {
        width: 1.25rem;
        height: 1.25rem;
    }
}
</style>
